import React from 'react';
import { EyeIcon } from 'lucide-react';

/**
 * Shown on the public pages when they are rendering the draft rather than the live
 * version, so a test site can never be mistaken for what fans actually see.
 */
export function DraftBanner() {
  return <div className="sticky top-0 z-[60] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-[#d97742] px-4 py-2 text-center text-[12.5px] font-medium text-white" data-id="element-938" data-mp="1romxvziug8nw">
      <span className="inline-flex items-center gap-1.5" data-id="element-939" data-mp="2kgon37rwnfb0">
        <EyeIcon className="h-3.5 w-3.5" data-id="element-940" data-mp="2pe876obaamav" /> Draft preview — this is not the live site
      </span>
      <a href="/" className="underline underline-offset-2 opacity-90 transition-opacity hover:opacity-100" data-id="element-941" data-mp="2beyx86do8ofc">
        View the live site
      </a>
    </div>;
}